import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the easySplit state domain
 */

const selectEasySplitDomain = state => state.easySplit || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by EasySplit
 */

const makeSelectEasySplit = () =>
  createSelector(
    selectEasySplitDomain,
    substate => substate,
  );

export default makeSelectEasySplit;
export { selectEasySplitDomain };
